const Files = () => {
  return (
    <div>
      <h4>Files go here</h4>
    </div>
  )
}

export default Files
